import React, { useState } from "react";
import { BasicTiptapEditor } from "@/components/tiptap/BasicTiptapEditor";
import { NotionLikeEditorWithProviders } from "@/components/tiptap/NotionLikeEditor";

export function TiptapTestPage() {
  const [content, setContent] = useState("<p>Hello Tiptap! 👋</p>");

  return (
    <div className="container mx-auto py-8 px-4">
      <div className="max-w-4xl mx-auto space-y-8">
        <div className="text-center">
          <h1 className="text-3xl font-bold mb-2">Tiptap Editor Test</h1>
          <p className="text-muted-foreground">
            Testing the Tiptap rich text editor installation
          </p>
        </div>

        <div className="space-y-4">
          <h2 className="text-xl font-semibold">Basic Editor</h2>
          <BasicTiptapEditor
            content={content}
            onChange={setContent}
            placeholder="Start typing to test the editor..."
          />
        </div>

        <div className="space-y-4">
          <h2 className="text-xl font-semibold">Read-Only Preview</h2>
          <BasicTiptapEditor content={content} editable={false} />
        </div>

        <div className="space-y-4">
          <h2 className="text-xl font-semibold">
            Notion-Like Editor (No Collaboration)
          </h2>
          <div className="border rounded-lg overflow-hidden">
            <NotionLikeEditorWithProviders
              content={content}
              onChange={setContent}
              placeholder="Try the Notion-like editor with slash commands..."
            />
          </div>
        </div>

        <div className="space-y-4">
          <h2 className="text-xl font-semibold">Raw HTML Output</h2>
          <div className="p-4 bg-muted rounded-lg">
            <pre className="text-sm overflow-auto">{content}</pre>
          </div>
        </div>

        <div className="space-y-2 text-sm text-muted-foreground">
          <h3 className="font-medium">Test Features:</h3>
          <ul className="list-disc pl-6 space-y-1">
            <li>
              <strong>Basic Editor:</strong> Try making text bold and italic,
              create headings
            </li>
            <li>
              <strong>Notion-Like Editor:</strong> Type "/" for slash commands
              menu
            </li>
            <li>Add emoji with ":" trigger (e.g., ":smile:")</li>
            <li>Mention users with "@" trigger</li>
            <li>Create task lists, code blocks, and more</li>
            <li>Drag and drop blocks to reorder them</li>
            <li>View the real-time HTML output below</li>
            <li>Check the read-only version updates automatically</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
